import { render, staticRenderFns } from "./LostOtpPolicy.vue?vue&type=template&id=ea5fd5ba&scoped=true"
import script from "./LostOtpPolicy.vue?vue&type=script&lang=js"
export * from "./LostOtpPolicy.vue?vue&type=script&lang=js"
import style0 from "./LostOtpPolicy.vue?vue&type=style&index=0&id=ea5fd5ba&prod&lang=scss&scoped=true"
import style1 from "./LostOtpPolicy.vue?vue&type=style&index=1&id=ea5fd5ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5fd5ba",
  null
  
)

export default component.exports